var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.fetched)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('div',[_c('h2',{staticClass:"preloader isLoading"},[_vm._v("Trwa ładowanie")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }